import React from 'react'
import RadioInput from '../Inputs/RadioInput.js'


const questions = [
    { question: "question1", optiona: "is full of energy.", optionb: "likes to cooperate with others." },
    { question: "question2", optiona: "is outgoing, sociable.", optionb: "does things efficiently." },
    { question: "question3", optiona: "enjoys expressing thoughts openly.", optionb: "is emotionally stable, not easily upset." },
    { question: "question4", optiona: "generates a lot of enthusiasm.", optionb: "has an active imagination." },
    { question: "question5", optiona: "is generally trusting.", optionb: "makes plans and follows through with them." },
    { question: "question6", optiona: "is easy to get along with.", optionb: "does not worry unnecessarily." },
    { question: "question7", optiona: "values maintaining harmony in relationships.", optionb: "is original, comes up with new ideas." },
    { question: "question8", optiona: "perseveres until the task is finished.", optionb: "is relaxed, handles stress well." },
    { question: "question9", optiona: "is reliable and dependable.", optionb: "values artistic, aesthetic experiences." },
    { question: "question10", optiona: "remains calm in tense situations.", optionb: "is curious about many different things." },
    { question: "question11", optiona: "generates a lot of enthusiasm.", optionb: "is easy to get along with." },
    { question: "question12", optiona: "is full of energy.", optionb: "is reliable and dependable." },
    { question: "question13", optiona: "is outgoing, sociable.", optionb: "does not worry unnecessarily." },
    { question: "question14", optiona: "enjoys being the center of attention.", optionb: "values artistic, aesthetic experiences." },
    { question: "question15", optiona: "likes to cooperate with others.", optionb: "does things efficiently." },
    { question: "question16", optiona: "values maintaining harmony in relationships.", optionb: "is emotionally stable, not easily upset." },
    { question: "question17", optiona: "is polite and respects others.", optionb: "is curious about many different things." },
    { question: "question18", optiona: "does a thorough job.", optionb: "is relaxed, handles stress well." },
    { question: "question19", optiona: "perseveres until the task is finished.", optionb: "is ingenious, a deep thinker." },
    { question: "question20", optiona: "remains calm in tense situations.", optionb: "has an active imagination." },
    { question: "question21", optiona: "is full of energy.", optionb: "is polite and respects others." },
    { question: "question22", optiona: "generates a lot of enthusiasm.", optionb: "does a thorough job." },
    { question: "question23", optiona: "is outgoing, sociable.", optionb: "is relaxed, handles stress well." },
    { question: "question24", optiona: "enjoys being the center of attention.", optionb: "is original, comes up with new ideas." },
    { question: "question25", optiona: "is polite and respects others.", optionb: "does a thorough job." },
    { question: "question26", optiona: "values maintaining harmony in relationships.", optionb: "remains calm in tense situations." },
    { question: "question27", optiona: "is generally trusting.", optionb: "is original, comes up with new ideas." },
    { question: "question28", optiona: "is reliable and dependable.", optionb: "does not worry unnecessarily." },
    { question: "question29", optiona: "perseveres until the task is finished.", optionb: "values artistic, aesthetic experiences." },
    { question: "question30", optiona: "is emotionally stable, not easily upset.", optionb: "has an active imagination." },
];

export default function FormPage2(props) {


    const questionsToShow = questions.slice(props.startIndex, props.startIndex + 3);


    const questionsMapped = questionsToShow.map((perQuestion, index) => {
        return (
            <RadioInput
                key={perQuestion.question}
                label={perQuestion.question}
                name={perQuestion.question}
                formData={props.formData}
                onChange={props.handleChange}
                optiona={perQuestion.optiona}
                optionb={perQuestion.optionb}
                questionNum={props.startIndex + index  /*This is used in the component to know which part of the array we're in */}
            />
        )
    })

    return (
        <form className="Form" >
            <div className="Form--inputs-container">
                <h4 className="Form--instructions">Choose the statement that best describes you.</h4>
                <div className="Form--questions-container">
                    {questionsMapped}
                </div>
            </div>


        </form>
    )
}